export default __webpack_public_path__ + "static/media/distance_light.c1ddaa5a.svg";